'use strict';

class HelpCenterSearch {
	constructor (options) {
		this.help_center_question = options.help_center_question;
		this.searched_question_id = options.searched_question_id;
		this.selected_category_id = options.selected_category_id;
		this.elements = options.elements;
		this.messages = options.messages;
		this.max_q = options.max_q; // changes max number of responses (not suggestions)

		this.timer = '';
		this.response = '';
		this.click_number = 0;
		this.search_string = '';
		this.last_search_string = '';

		this.pageEvents();

		if (this.help_center_question && !this.searched_question_id) {
			this.hideSuggestions();
			this.submitSearch(this.search_string, null, 'search-suggestions', 5);
		}

		if (this.selected_category_id && window.innerWidth < 992) {
			const selector = document.querySelector(`[data-category-id="${this.selected_category_id}"]`);
			const navbarHeight = document.querySelector('.navbar-kc').offsetHeight;
			const offset = navbarHeight + 5;

			this.scrollIntoViewWithOffset(selector, offset);
		}
	}

	pageEvents() {
		this.elements.need_help.addEventListener('click', (e) => {
			e.target.setSelectionRange(0, e.target.value.length);
		});

		this.elements.need_help.addEventListener('blur', (e) => {
			if (e.target.value === '') {
				this.elements.question_suggestions.classList.add('d-none');
			}
		});

		this.elements.need_help.addEventListener('keyup', (event) => {
			this.keyupSearchHandler(event);
		});

		this.elements.need_help_button.addEventListener('click', () => {
			this.search_string = this.elements.need_help.value;

			if (this.search_string.length >= 3) {
				this.hideSuggestions();
				this.submitSearch(this.search_string, null, 'search-suggestions', 5);
			}
		});

		// Bind click events for dynamic content
		document.addEventListener('click', (event) => {
			const questionSelector = event.target.closest('.search-response-track-click');

			if (questionSelector) {
				const questionId = questionSelector.getAttribute('data-id');
				if (questionId) {
					this.handleLogClick(questionId);
					window.location.href = s.url('help_center', {
						qid: questionId
					});
					this.hideSuggestions();
				}
			}
		});
	}

	scrollIntoViewWithOffset (element, offset) {
		window.scrollTo({
			behavior: 'smooth',
			top: element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset
		});
	}

	showLoadingSpinner() {
		if (this.elements.need_help_spinner) {
			this.elements.need_help_spinner.classList.remove('d-none');
		}
	}

	hideLoadingSpinner() {
		if (this.elements.need_help_spinner) {
			this.elements.need_help_spinner.classList.add('d-none');
		}
	}

	hideSuggestions() {
		if (this.elements.question_suggestions) {
			this.elements.question_suggestions.classList.add('d-none');
			this.elements.question_suggestions.classList.remove('search-suggestions');
		}
	}

	showSuggestions() {
		if (this.elements.question_suggestions) {
			this.elements.question_suggestions.classList.remove('d-none');
			this.elements.question_suggestions.classList.add('search-suggestions');
		}
	}

	hideResponse() {
		if (this.elements.question_response && this.elements.question_response.dataset.type === 'modal') {
			this.elements.question_response.classList.add('d-none');
		}
	}

	showNoResultsMessage() {
		const suggestionsList = this.elements.question_suggestions.querySelector('ul');

		suggestionsList.innerHTML = `<li class='not-found'>${this.messages.NO_RESULTS_FOUND}</li>`;
	}

	showErrorTypeMessage() {
		const suggestionsList = this.elements.question_suggestions.querySelector('ul');

		suggestionsList.innerHTML = `<li class='not-found'>${this.messages.HELP_CENTER_CONTINUE_TYPE}</li>`;
	}

	/**
	 * Validates a provided search string, and if valid, calls submitRequest
	 *
	 * @param {string}  search_string   searched string
	 * @param {int}     search_id       searched question ID
	 * @param {string}  div             Id if the element
	 * @param {int}     max_q           Max number of responses
	 *
	 */
	submitSearch(search_string, search_id, div, max_q) {
		this.last_search_string = search_string;

		search_string = this.elements.need_help.value;
		search_string = s.trim(search_string.replace(/ +/g, ' '));

		if (search_string.length >= 2 && search_string !== this.messages.QNA_TYPE_KEYWORD) {
			this.submitRequest(search_string, search_id, div, max_q, 0);
		}
	}

	/**
	 * Gets the top responses from help_center_process and
	 * Displays the suggestions or answers depending on the 'div' param
	 *
	 * @param {string}  search_string   searched string
	 * @param {int}     search_id       question ID
	 * @param {string}  div             Id if the element
	 * @param {int}     max_q           Max number of responses
	 * @param {int}     auto            Log search or not ( log_search in help_center_process )
	 *
	 */
	submitRequest(search_string, search_id, div, max_q, auto) {
		if (!max_q) {
			max_q = 5;
		}

		if (s.options.page_ajax.request) {
			s.options.page_ajax.request.abort();
		}

		this.showLoadingSpinner();

		let formData = new FormData();
		formData.append('action', 'search');
		formData.append('message', search_string);
		formData.append('question_id', search_id);
		formData.append('qid', search_id);
		formData.append('max_q', max_q);
		formData.append('auto', auto);

		s.options.page_ajax.request = s.common.fetcher(
			s.url('help_center_process'),
			{
				method: 'POST',
				body: formData,
			}
		);

		s.options.page_ajax.request.ready.then(response => {
			if (div === 'search-suggestions') {
				this.showSuggestions();
				if (this.elements.question_suggestions) {
					const suggestionsList = this.elements.question_suggestions.querySelector('ul');

					if (response.length > 0) {
						const re = new RegExp(search_string, 'gi');
						suggestionsList.innerHTML = '';
						response.forEach((suggestionItem) => {
							const suggestionItemText = suggestionItem['question'].replace(re, '<strong>$&</strong>');
							suggestionsList.innerHTML += `<li class='suggestion-li cursor-pointer search-response-track-click' data-id='${suggestionItem['id']}'>${suggestionItemText}</li>`;
						});
					} else {
						this.showNoResultsMessage();
					}
				}
			}
		}).catch(() => {
			this.showNoResultsMessage();
		}).finally(() => {
			this.hideLoadingSpinner();
			this.hideResponse();
		});
	}

	/**
	 * Log a click on a question. Helps in providing the top answers for a specific question
	 *
	 * @param {string}  question_id
	 *
	 */
	handleLogClick(question_id) {
		this.click_number++;

		try {
			const form_data = new FormData();
			form_data.append('action', 'log');
			form_data.append('from', 'search');
			form_data.append('message', this.last_search_string);
			form_data.append('question_id', question_id);
			form_data.append('click_number', this.click_number);
			const fetch = s.common.fetcher(s.url('help_center_process'), {
				method: 'post',
				body: form_data
			});
			console.log('HelpCenterSearch::handleLogClick question(%o) success', question_id);
			return fetch.ready;
		} catch (e) {
			console.error('HelpCenterSearch::handleLogClick question(%o) failed', question_id);
		}
	}

	resetSearch() {
		this.elements.need_help.value = '';
		this.elements.need_help.focus();
	}

	keyupSearchHandler(event) {
		const suggestionsList = this.elements.question_suggestions.querySelector('ul');
		const suggestionsItems = suggestionsList.querySelectorAll('li');
		let suggestionItemActiveIndex = 0;

		clearTimeout(this.timer);

		if (event.key === 'Escape') {
			this.resetSearch();
			this.hideSuggestions();
		}

		if (suggestionsItems.length > 1) {
			switch (event.key) {
				case 'ArrowUp':
					suggestionItemActiveIndex = 0;
					suggestionsItems.forEach((item, index) => {
						if (item.classList.contains('active')) {
							suggestionItemActiveIndex = index + 1;
						}
					});
					suggestionItemActiveIndex--;
					if (suggestionItemActiveIndex < 1) {
						suggestionItemActiveIndex = 1;
					}
					suggestionsItems.forEach((item) => {
						item.classList.remove('active');
					});
					suggestionsList.querySelector('li:nth-child(' + suggestionItemActiveIndex + ')').classList.add('active');
					break;

				case 'ArrowDown':
					suggestionItemActiveIndex = 0;
					suggestionsItems.forEach((item, index) => {
						if (item.classList.contains('active')) {
							suggestionItemActiveIndex = index + 1;
						}
					});
					suggestionItemActiveIndex++;
					if (suggestionItemActiveIndex > suggestionsList.childElementCount) {
						suggestionItemActiveIndex = suggestionsList.childElementCount;
					}
					suggestionsItems.forEach((item) => {
						item.classList.remove('active');
					});
					suggestionsList.querySelector('li:nth-child(' + suggestionItemActiveIndex + ')').classList.add('active');
					break;

				default:
					break;
			}
		}

		if (!event.altKey && !event.ctrlKey && !event.shiftKey && !event.metaKey) {
			const forbiddenKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab', 'Escape', 'CapsLock'];
			if (!forbiddenKeys.includes(event.key)) {
				this.search_string = event.target.value;
				let suggestionItemActive = document.querySelector('#search-suggestions ul li.active');

				if (this.search_string.length >= 3) {
					suggestionsList.innerHTML = '';
					if (event.key === 'Enter') {
						let questionId = suggestionItemActive ? suggestionItemActive.dataset.id : '';

						if (questionId) {
							if (s.options.page_ajax.request) {
								s.options.page_ajax.request.abort();
							}
							this.hideLoadingSpinner();
							this.handleLogClick(questionId);
							window.location.href = s.url('help_center', {
								qid: questionId
							});
						}
					} else {
						this.timer = setTimeout(() => {
							this.submitSearch(this.search_string, null, 'search-suggestions', 5);
						}, 500);
					}
				} else {
					this.timer = setTimeout(() => {
						this.hideLoadingSpinner();
						this.showSuggestions();
						this.showErrorTypeMessage();
					}, 500);
				}
			}
		}
	}
}
